import { Injectable } from '@angular/core';
import {HttpService} from '../http.service';
import {ISpecial} from '@api/models/specials/specials';
import {IDefaultListResponse, IDefaultResponse, IDefaultResponseT} from '@api/models/default-response/response';

@Injectable({
  providedIn: 'root'
})
export class SpecialsHttpService {

  constructor( private http: HttpService ) { }

  public async putSpecials(specials: ISpecial[]): Promise<IDefaultListResponse<ISpecial>> {
    return this.http.put<IDefaultListResponse<ISpecial>>(['v2/specials', 'many'], { specials }).toPromise();
  }

  public async getSpecials(): Promise<IDefaultListResponse<ISpecial>> {
    return this.http.get<IDefaultListResponse<ISpecial>>(['v2/specials', 'all']);
  }

  public async postSpecial(special: ISpecial): Promise<IDefaultResponseT<ISpecial>> {
    return this.http.post<IDefaultResponseT<ISpecial>>(['v2/specials'], special).toPromise();
  }

  public async deleteSpecial(specialId: string): Promise<IDefaultResponse> {
    return this.http.delete(['v2/specials', specialId]).toPromise();
  }
}
